enum EDreamAttribute {
	board,
	buy,
	campaign,
	decision,
	direction,
	fascination,
	fixed,
	in_progress,
	indirect,
	important,
	prayer,
	problem,
	reading,
	tentative,
	someday,
	unclean,
	waypoint,
}

export type EDA = EDreamAttribute;
export const EDA = EDreamAttribute;